/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-03-07 10:11:17
 */
import {createI18n} from 'vue-i18n';
import zh from '@/i18n/zh.js';
import en from '@/i18n/en.js';

const messages = {
    zh,en
}

const locale = localStorage.getItem('lang')? localStorage.getItem('lang') : 'zh'
// const locale = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en'

const i18n = createI18n({
    legacy:false, // 使用 Composition API 模式，则需要将其设置为false
    globalInjection:true, // // 全局注入 $t 函数
    locale:locale,
    messages:messages
})

export default i18n